(function() {
  function getOrthodoxEaster(year) {
    var a = year % 4;
    var b = year % 7;
    var c = year % 19;
    var d = (19 * c + 15) % 30;
    var e = (2 * a + 4 * b - d + 34) % 7;
    var month = Math.floor((d + e + 114) / 31);
    var day = ((d + e + 114) % 31) + 1;
    var date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + 13);
    return date;
  }

  function getBulgarianHolidays(year) {
    var fixed = [[0,1],[2,3],[4,1],[4,6],[4,24],[8,6],[8,22],[11,24],[11,25],[11,26]];
    var fixedDates = fixed.map(function(h) { return new Date(year, h[0], h[1]); });
    var easter = getOrthodoxEaster(year);
    var easterDates = [];
    [-2,-1,0,1].forEach(function(off) {
      var d = new Date(easter);
      d.setDate(d.getDate() + off);
      easterDates.push(d);
    });
    var holidays = fixedDates.concat(easterDates);
    var extra = [];
    fixedDates.forEach(function(h) {
      var dow = h.getDay();
      if (dow === 6 || dow === 0) {
        var comp = new Date(h);
        comp.setDate(comp.getDate() + (dow === 6 ? 2 : 1));
        while (holidays.concat(extra).some(function(d) { return sameDay(d, comp); })) {
          comp.setDate(comp.getDate() + 1);
        }
        extra.push(comp);
      }
    });
    return holidays.concat(extra);
  }

  function sameDay(a, b) {
    return a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  }

  function isHoliday(date, holidays) {
    return holidays.some(function(h) { return sameDay(h, date); });
  }

  function isNonWorkingDay(date, holidays) {
    var dow = date.getDay();
    return dow === 0 || dow === 6 || isHoliday(date, holidays);
  }

  function skipNonWorkingDays(date, holidays) {
    var d = new Date(date);
    var i = 0;
    while (isNonWorkingDay(d, holidays) && i < 15) {
      d.setDate(d.getDate() + 1);
      i++;
    }
    return d;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function calculateDeliveryDate() {
    var now = new Date();
    var dow = now.getDay();
    var add1, add2;

    switch (dow) {
      case 5: add1 = 3; add2 = 4; break;
      case 4: add1 = 1; add2 = 4; break;
      case 3: add1 = 1; add2 = 2; break;
      default: add1 = 1; add2 = 2; break;
    }

    var d1 = new Date(now); d1.setDate(d1.getDate() + add1);
    var d2 = new Date(now); d2.setDate(d2.getDate() + add2);

    var holidays = getBulgarianHolidays(d1.getFullYear());
    if (d1.getMonth() === 11) {
      holidays = holidays.concat(getBulgarianHolidays(d1.getFullYear() + 1));
    }

    d1 = skipNonWorkingDays(d1, holidays);
    d2 = skipNonWorkingDays(d2, holidays);

    if (d2 <= d1) {
      d2 = new Date(d1);
      d2.setDate(d2.getDate() + 1);
      d2 = skipNonWorkingDays(d2, holidays);
    }

    return pad(d1.getDate()) + '.' + pad(d1.getMonth() + 1) + ' \u0438 ' + pad(d2.getDate()) + '.' + pad(d2.getMonth() + 1);
  }

  function fixDeliveryDates() {
    var jsDate = calculateDeliveryDate();
    document.querySelectorAll('[data-delivery-date]').forEach(function(el) {
      var liquidDate = el.getAttribute('data-delivery-date');
      if (jsDate !== liquidDate) {
        el.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.indexOf(liquidDate) !== -1) {
            node.textContent = node.textContent.replace(liquidDate, jsDate);
          }
        });
        el.setAttribute('data-delivery-date', jsDate);
      }
    });
  }

  fixDeliveryDates();
  document.addEventListener('cart:updated', fixDeliveryDates);
  document.addEventListener('shopify:section:load', fixDeliveryDates);
})();
